export const fr = {
  consent: {
    title: 'Nous respectons votre vie privée',
    description:
      "Nous utilisons des témoins (cookies) et des technologies similaires pour faire fonctionner ce site, comprendre son utilisation et soutenir notre marketing. Vous pouvez tout accepter, refuser les témoins non essentiels ou choisir ceux à autoriser. Vous pouvez modifier votre choix à tout moment.",
    acceptAll: 'Tout accepter',
    rejectAll: 'Tout refuser',
    managePreferences: 'Gérer les préférences',
    savePreferences: 'Enregistrer les préférences',
    preferencesTitle: 'Préférences de témoins',
    preferencesDescription:
      'Choisissez les catégories que vous autorisez. Les témoins strictement nécessaires sont toujours actifs, car le site ne peut pas fonctionner sans eux.',
    alwaysOn: 'Toujours actif',
    categories: {
      necessary: {
        title: 'Strictement nécessaires',
        description:
          "Requis pour le fonctionnement du site, y compris la connexion et la sécurité de votre session. Ils ne peuvent pas être désactivés.",
      },
      analytics: {
        title: 'Analytique',
        description:
          'Nous aident à comprendre comment les visiteurs utilisent le site afin de l’améliorer.',
      },
      marketing: {
        title: 'Marketing',
        description:
          'Nous permettent de mesurer nos campagnes et de comprendre quels visiteurs s’intéressent à Purposely.',
      },
    },
  },
}
